
import {
  defineComponent, PropType, ref, watch,
} from 'vue'
import IconSpinner from '@/vue/icons/IconSpinner.vue'
import { useStore } from 'vuex'
import { key } from '@/vue/store'

export default defineComponent({
  name: 'AdminWrapper',
  props: {
    noStore: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: { IconSpinner },
  setup(props) {
    const loading = ref(false)
    if (!props.noStore) {
      const store = useStore(key)
      loading.value = store.state.routeLoading
      watch(() => store.state.routeLoading, () => {
        loading.value = store.state.routeLoading
      })
    }
    return { loading }
  },
})
